import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

import { updateSingleProduct } from "../../../actions/singleProductAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllContactMerchandiser } from "../../../actions/contactAction";
import { getAllLocation, getAllLocationForDetails  } from "../../../actions/warehouseAction";
import { getspecificproductvariation } from "../../../actions/variableProductAction";
import { getAllAttribute } from "../../../actions/attributeAction";
import {
  createVariationfromEdit,
  updateVariation,
  updateVariationCustom,
  deleteVariation,
} from "../../../actions/variableProductAction";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  TreeSelect,
  Divider,
  Drawer,
  Skeleton,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

const SingleProductDetailsTable = ({
  List,
  getAllCategory,
  getAllContactMerchandiser,
  Merchandiser,
  getAllLocation,
  getAllLocationForDetails,
  getAllAttribute,
  updateSingleProduct,
  details,
  setUpdatelist,
  settrigger,
  getspecificproductvariation,
  Attribute,
  Warehouse,
  PreVariations,
  createVariationfromEdit,
  updateVariation,
  updateVariationCustom,
  deleteVariation,
  setreload,
  auth,
}) => {
  const [formdata, setformdata] = useState(false);
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const updateddata = useRef([]);
  const load = useRef(true);

  useEffect(() => {
    // console.log("useEffect");
  }, [visible]);

  const onFinish = (values) => {
    let promises = [];
    if (typeof values.Category != "number") {
      values.Category = values.Category.id;
    }

    // if (values.Variations.length > 0) {
    //   values.Variations.forEach((element) => {
    //     const keys = Object.keys(element);
    //     // console.log(keys);
    //     const attributes = [];
    //     keys.forEach((key, index) => {
    //       // console.log(`${key}: ${element[key]}`);
    //       Attribute.map((e) => {
    //         if (
    //           key == e.name &&
    //           typeof element[key] != "undefined" &&
    //           element[key] != null
    //         ) {
    //           if (typeof element[key] == "object") {
    //             attributes.push(element[key].id);
    //           } else {
    //             attributes.push(element[key]);
    //           }
    //         }
    //       });
    //     });
    //     element["Attribute"] = attributes;
    //   });
    // }

    updateSingleProduct(details.id, values).then((result) => {
      for (let Variation in values.Variations) {
        if (typeof values.Variations[Variation].id == "undefined") {
          promises.push(
            createVariationfromEdit(details.id, values.Variations[Variation])
          );
        } else {
          promises.push(
            updateVariation(
              values.Variations[Variation].id,
              values.Variations[Variation]
            )
          );
        }
      }
      Promise.all(promises).then((result) => {
        form.resetFields();
        setUpdatelist(false);
        setformdata(false);
        setVisible(false);
        setreload(true);
      });
    });
  };

  const loadattributes = (name, fieldKey, restField) => {
    return Attribute.map((attribute) => (
      <>
        <Col span={2}>
          <Form.Item
            label={attribute.name}
            {...restField}
            name={[name, attribute.name]}
            fieldKey={[fieldKey, "key"]}
          >
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {attribute.terms.map((item) => {
                return <Option value={item.id}>{item.name}</Option>;
              })}
            </Select>
          </Form.Item>
        </Col>
      </>
    ));
  };

  const showDrawer = () => {
    load.current = true;
    updateddata.current = [];
    setVisible(true);
    getAllCategory();
    getAllContactMerchandiser();
    // getAllLocation();
    getAllLocationForDetails();
    getAllAttribute();
    // asyncCall();
    getspecificproductvariation(details.id).then((result) => {
      details.Variations = result;
      for (let i = 0; i < details.Variations.length; i++) {
        details.Variations[i].Color = details.Variations[i].Color;
        details.Variations[i].Size = details.Variations[i].Size;
        details.Variations[i].Warehouse = details.Variations[i].Warehouse;
        details.Variations[i].ProductDetails =
          details.Variations[i].ProductDetails.id;
      }
      details.Discount = {
        discount: details.discount,
      };

      details.Discount_type = {
        discount_type: details.discount_type,
      };
      load.current = false;
      form.resetFields();
      updateddata.current = details;

      setformdata(true);
      form.setFieldsValue(details);
    });
  };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
    setformdata(false);
  };

  const handleEcommerceRegularPriceChange = (value) => {
    const maxPrice = form.getFieldValue('max_price');
    
    if (maxPrice && value) {
      // Calculate discount percentage: ((maxPrice - ecommercePrice) / maxPrice) * 100
      const discountPercentage = ((maxPrice - value) / maxPrice) * 100;
      
      // Round to 2 decimal places
      const roundedPercentage = Math.round(discountPercentage * 100) / 100;
      
      // Set the calculated percentage in the form
      form.setFieldsValue({
        ecommerce_discount_percentage: roundedPercentage >= 0 ? roundedPercentage : 0
      });
    } else {
      // Clear the percentage if either value is empty
      form.setFieldsValue({
        ecommerce_discount_percentage: null
      });
    }
  };

  const renderdata = () => {
    if (updateddata.current === details) {
      return (
        <>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={details}
          >
            <Divider>Basic details</Divider>
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item
                  name="product_code"
                  label="Style Name"
                  rules={[
                    { required: true, message: "Please enter Style Name" },
                  ]}
                >
                  <Input placeholder="Please enter Style Name" />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  name="title"
                  label="Product SKU"
                  rules={[
                    { required: true, message: "Please enter product SKU" },
                  ]}
                >
                  <Input placeholder="product SKU" />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  name="slug"
                  label="Product Slug"
                  rules={[
                    { required: true, message: "Please enter product slug" },
                  ]}
                >
                  <Input placeholder="product slug" />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="Category" label="Category">
                  <TreeSelect treeData={List} />
                </Form.Item>
              </Col>
                            
              <Col span={4}>
                <Form.Item label="Total Product Quantity" name={"quantity"}>
                  <Input
                    // addonBefore="BDT"
                    type="number"
                    
                    disabled
                  />
                </Form.Item>
              </Col>

            </Row>
      
            <Divider>E-commerce</Divider>
            
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name="name"
                  label="Ecommerce Meta Title"
                  // rules={[
                  //   { required: true, message: "Ecommerce Product Title" },
                  // ]}
                >
                  <Input placeholder="Ecommerce Meta Title" />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="max_price" label="Regular Selling Price">
                  <Input
                  disabled
                    addonBefore="BDT"
                    type="number"
                    placeholder="Regular Selling Price"
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="ecommerce_regular_price" label="Ecommerce Discounted Price">
                  <Input
                    addonBefore="BDT"
                    type="number"
                    placeholder="Ecommerce Discounted Price"
                    onChange={(e) => handleEcommerceRegularPriceChange(e.target.value)}
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="ecommerce_discount_percentage" label="Ecommerce Percentage">
                  <Input
                    addonBefore="%"
                    type="number"
                    placeholder="Ecommerce Percentage"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="meta_description" label="Meta Drescription">
                  <Input.TextArea rows={2} placeholder="Meta Drescription For Ecommerce" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={10}>
                <Form.Item name="Short_description" label="Short Drescription">
                  <Input.TextArea rows={4} placeholder="Short Drescription For Ecommerce" />
                </Form.Item>
              </Col>
              <Col span={14}>
                <Form.Item name="long_description" label="Long Drescription">
                  <Input.TextArea rows={4} placeholder="Long Drescription For Ecommerce" />
                </Form.Item>
              </Col>
            </Row>

            <Divider></Divider>
            <h3>Additional Information</h3>
            <Row gutter={16}>
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item name="is_active" valuePropName="checked" checked>
                    <Checkbox>Active Product !</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="is_ecommerce" valuePropName="checked" >
                    <Checkbox>Ecommerce Product !</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="is_new_arrival" valuePropName="checked" >
                    <Checkbox>New Arrival Product</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="is_best_seller" valuePropName="checked" >
                    <Checkbox>Best Seller Product</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </Row>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </>
      );
    } else {
      return <Skeleton active />;
    }
  };

  return (
    <>
      {auth.permissions.includes("Products.All products_is_update") ? (
        <a href="#" onClick={showDrawer} style={{ margin: 4 }}>
          Edit
        </a>
      ) : (
        ""
      )}
      <Drawer
        title={details.title}
        width="90%"
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        {renderdata()}
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    List: state.category.categorylist,
    Warehouse: state.warehouse.locationlist,
    Attribute: state.attribute.attributelist,
    PreVariations: state.ProductDetails.productdetails,
    auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getAllCategory,
  getAllContactMerchandiser,
  getAllLocation,
  getAllLocationForDetails,
  getAllAttribute,
  updateSingleProduct,
  getspecificproductvariation,
  createVariationfromEdit,
  updateVariation,
  updateVariationCustom,
  deleteVariation,
})(SingleProductDetailsTable);
